import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StatusDialog = ({ openStatus, handleCloseStatus, onSelect }) => {
  const statusOptions = [
    { label: "Diterima", value: 1 },
    { label: "Diproses", value: 2 },
    { label: "Selesai Dikerjakan", value: 3 },
    { label: "Dibayar", value: 4 },
    { label: "Diklaim", value: 5 },
    { label: "Dibatalkan", value: 6 },
  ];
  return (
    <Dialog
      fullScreen
      open={openStatus}
      onClose={handleCloseStatus}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseStatus}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
      <>
      {statusOptions.map((status, index) => (
        <Box
          key={index}
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
            cursor: "pointer",
            "&:hover": {
              bgcolor: "#f0f0f0",
            },
          }}
          // onClick={() => onSelect(status.value)}
          onClick={() => onSelect(status.value, status.label)}
        >
          <Typography variant="caption" color="text.secondary" display="block">
            {status.label}
          </Typography>
        </Box>
      ))}
    </>
      </Box>
    </Dialog>
  );
};

export default StatusDialog;
